import axios from "axios";

export default function SafetyWorktypeRemoveService(formData, safetyId) {
  return axios({
    method: 'DELETE',
    url: process.env.REACT_APP_API_HOST + "/safety/" + safetyId + "/worktypes",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
